import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, ArrowRightIcon } from 'lucide-react';
const audiences = [{
  title: 'Jugadores estancados',
  desc: 'Intermedios y avanzados que repiten los mismos errores sin progresar a un juego de élite.'
}, {
  title: 'Entrenas en club o en casa',
  desc: 'Con una mesa y un compañero (o robot) te alcanza.'
}, {
  title: 'Jugadores que quieren dar clases',
  desc: 'Querés transmitir tu conocimiento técnico y convertirte en un coach estructurado.'
}, {
  title: 'Buscás dominio técnico absoluto',
  desc: 'Vas por el control total del loop, el juego de pies rápido y la letalidad en la tercera pelota.'
}];
export function AudienceSection() {
  return <section className="py-10 sm:py-16 lg:py-24 bg-navy-800 relative overflow-hidden" data-id="element-19">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-radial-glow opacity-30 pointer-events-none" data-id="element-20" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-21">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16" data-id="element-22">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display text-offwhite uppercase mb-3" data-id="element-23">
            ¿PARA QUIÉN <span className="text-gold-500" data-id="element-24">ES?</span>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-text-secondary max-w-2xl mx-auto" data-id="element-25">
            Diseñado para vos si querés llevar tu juego al próximo nivel
            competitivo en los próximos 30 días.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:gap-5 max-w-4xl mx-auto" data-id="element-26">
          {audiences.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} whileHover={{
          scale: 1.02,
          borderColor: 'rgba(212, 168, 87, 0.5)'
        }} whileTap={{
          scale: 0.98,
          borderColor: 'rgba(212, 168, 87, 0.8)'
        }} className="bg-navy-900 border border-navy-700 p-3 sm:p-6 rounded-xl flex flex-col sm:flex-row gap-2 sm:gap-4 shadow-lg cursor-pointer transition-colors" data-id="element-27">
              <CheckCircle2Icon className="w-5 h-5 sm:w-6 sm:h-6 text-gold-400 flex-shrink-0 mt-0.5" data-id="element-28" />
              <div data-id="element-29">
                <h3 className="font-bold text-offwhite text-xs sm:text-sm md:text-lg mb-1 leading-tight" data-id="element-30">
                  {item.title}:
                </h3>
                <p className="text-text-secondary text-[10px] sm:text-xs md:text-sm leading-relaxed" data-id="element-31">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-8 sm:mt-12 text-center" data-id="element-32">
          <a href="#garantia" className="inline-flex items-center gap-1.5 sm:gap-2 text-gold-400 hover:text-gold-300 font-semibold transition-colors group text-xs sm:text-sm md:text-base" data-id="element-33">
            ¿No estás seguro si es para vos? Tenés 7 días de garantía
            <ArrowRightIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 group-hover:translate-x-1 transition-transform" data-id="element-34" />
          </a>
        </motion.div>
      </div>
    </section>;
}